// 外部审查(非必须)
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行--项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>

    <!-- 第二行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:12px;">*请上传评审意见（若项目不需要评审，可以直接提交）。</div>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'33'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import UploadFile from '../UploadFile'
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      detailsImgList: [],
      submitImgList: [],
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      addFormData: {
        four_annex: '',
      },
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/ereview_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)

        param.append('annex', JSON.stringify(this.submitImgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/ereview',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/ereview_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name

      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
        console.log('外部审查文件', this.detailsImgList, this.submitImgList)
      }
      this.isComponentsShow = true
      console.log('外部审查(非必须-详情', this.addFormData)
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>